var _style, _g, _path, _path2, _path3, _polygon, _polygon2, _polygon3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon4, _g2, _path14, _path15, _path16, _path17, _line, _path18, _line2, _path19, _path20, _path21, _g3, _g4, _rect, _polygon5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#EEF6FD;}\n\t.st1{opacity:0.3;fill-rule:evenodd;clip-rule:evenodd;fill:#C4D7F4;enable-background:new    ;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#E1ECF9;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#EFF6FF;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#A6B6C9;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#9CABBD;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#97A5B6;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#9CACC0;}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#C8D6E7;}\n\t.st10{fill:none;stroke:#9CACC0;stroke-width:0.5;}\n\t.st11{fill:none;stroke:#1D5194;stroke-width:0.5;}\n\t.st12{opacity:0.5;fill-rule:evenodd;clip-rule:evenodd;fill:#B6C3D5;enable-background:new    ;}\n\t.st13{fill:none;stroke:#E2EAF7;stroke-width:0.5;stroke-linecap:round;}\n\t.st14{fill:#C8D6E7;}\n\t.st15{fill:#FFFFFF;}\n\t.st16{opacity:0.5;fill:#A6B6C9;enable-background:new    ;}\n\t.st17{fill:none;stroke:#A6B6C9;stroke-width:0.5;}\n\t.st18{opacity:0.7769;fill-rule:evenodd;clip-rule:evenodd;fill:#A6B6C9;enable-background:new    ;}\n\t.st19{fill:none;stroke:#B9C5D4;stroke-width:0.648;stroke-linecap:round;}\n\t.st20{fill:none;stroke:#B6C3D5;stroke-width:0.5;stroke-linecap:round;}\n\t.st21{fill:none;stroke:#B9C5D4;stroke-width:0.5;}\n\t.st22{fill:none;stroke:#A6B6C9;stroke-width:0.5;stroke-linecap:round;}\n\t.st23{opacity:0.5255;fill-rule:evenodd;clip-rule:evenodd;fill:#E7F0F1;enable-background:new    ;}\n\t.st24{fill-rule:evenodd;clip-rule:evenodd;fill:#E7F0F1;}\n\t.st25{fill-rule:evenodd;clip-rule:evenodd;fill:#FFC107;}\n\t.st26{fill:#FFB9B4;}\n\t.st27{fill:#D38E89;}\n\t.st28{fill:none;stroke:#FFF4C4;stroke-width:0.4196;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st29{fill:#E7F0F1;}\n\t.st30{fill:#001E50;}\n\t.st31{fill:#001841;}\n\t.st32{fill:#00BAD4;}\n\t.st33{fill:none;stroke:#FFC107;stroke-width:1.6782;stroke-miterlimit:10;}\n\t.st34{fill:#D38E89;stroke:#D38E89;stroke-width:2.0978;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st35{fill:none;stroke:#001841;stroke-width:3.3565;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st36{fill:none;stroke:#161C30;stroke-width:2.9369;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st37{fill:#005E6A;}\n\t.st38{fill:#FFE7E6;}\n\t.st39{fill:#FAE8D2;stroke:#FFFFFF;stroke-width:0.7463;stroke-miterlimit:10;}\n\t.st40{fill:none;stroke:#FFFFFF;stroke-width:0.5597;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st41{fill:none;stroke:#FE7055;stroke-width:3.579;stroke-miterlimit:10;}\n\t.st42{fill:#01B1C9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path-29",
    className: "st0",
    d: "M493.3,267.8c10.1,71-26.1,120.5-103.5,127.3s-95.3-51-131.6-40.8s-99.4,14.9-137.6,7.5 C82.5,354.3,5.8,344.3,5.8,215.9S88.6,33.6,182,29.4S351.8,53.2,404.8,104S483.2,196.8,493.3,267.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-6",
    className: "st1",
    d: "M325.8,117.3v180.1c0,4.4-3.6,8-8,8H40.4c-4.4,0-8-3.6-8-8V117.3c0-4.4,3.6-8,8-8h277.4 C322.2,109.3,325.8,112.9,325.8,117.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6_00000060027724483816206950000002573003699556328372_",
    transform: "translate(190.922133, 65.267473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    className: "st2",
    d: "M149.9,37v180.1c0,4.4-3.6,8-8,8h-277.4c-4.4,0-8-3.6-8-8V37c0-4.4,3.6-8,8-8h277.4 C146.3,29,149.9,32.6,149.9,37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-7",
    className: "st3",
    d: "M135.4,49.4v158.3c0,3.5-2.9,6.4-6.4,6.4h-252c-3.5,0-6.4-2.9-6.4-6.4V49.4 c0-3.5,2.9-6.4,6.4-6.4h252C132.5,43,135.4,45.9,135.4,49.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(83.420277, 24.015690)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 51.345459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    transform: "translate(109.969554, 49.628831) rotate(-131.000000) translate(-109.969554, -49.628831) translate(71.787155, 17.973580)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    className: "st4",
    d: "M144-154.6c-1.3,3.2-1.3,6.8,0,10.1l6.3,16.5l24.3-0.1L161.3-152l31.4-29.5l-5.5-6.8l0,0 l-36.8,25.5C147.5-160.7,145.3-157.8,144-154.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(14.905916, 51.392918) rotate(24.000000) translate(-14.905916, -51.392918) translate(1.788317, 44.196848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-26",
    className: "st2",
    d: "M63.3-292.9c11.8,7,18.4,10.6,19.7,10.7c1.9,0.2,2.7-1.3,2.8-2.1c0.1-0.8-0.5-1.4-2.8-2.6 c-2.3-1.2-17.8-8.4-18.4-8.6c-0.6-0.2-1.1-0.5-1.4-0.1c-0.2,0.3-0.2,0.6,0.1,0.9L63.3-292.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-25",
    className: "st5",
    d: "M79.6-274.8L79.6-274.8c1.4-0.7,2.4-1.7,3.2-2.8c0.8-1.2,1.2-2.7,1.3-4.6 c-7.5-5.4-14.4-9.6-20.8-12.4c-1.8,1.2-1.6,2.4-0.7,3.7c0.9,1.3,3.3,3.7,4.9,7.1s2.7,6.3,3.9,6.1c1.2-0.2,3.2-1.2,4.7-0.5 c0.9,0.4,1.9,1.5,3,3.3C79.2-274.8,79.4-274.7,79.6-274.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st6",
    d: "M70.6-278c1.7-1.7,3.7-2.1,5.7-1.3c1.6,0.7,2.8,2.1,3.5,4.2l0,0l-0.1,0.1l-0.2,0.1l0,0 c-0.2,0.1-0.4,0-0.5-0.2c-1.1-1.8-2.1-2.9-3-3.3s-2-0.2-3,0.1l-0.3,0.1l0,0l-0.5,0.2l0,0l-0.3,0.1c-0.2,0.1-0.4,0.1-0.6,0.1 C71.1-277.7,70.9-277.8,70.6-278L70.6-278z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000049920474784412120830000002098398146057067184_",
    className: "st6",
    d: "M64.7-288.2c1.8,0.5,3.6,2.1,5.4,4.8 l0.2,0.3c0.6,0.9,1.2,1.9,1.8,3l0.2,0.4c0,0.1,0.1,0.2,0.1,0.2l0.2,0.5c0.1,0.2,0.2,0.5,0.4,0.7c-0.1,0-0.1,0-0.2,0l-0.6,0.2 l0,0l-0.3,0.1c-0.2,0.1-0.4,0.1-0.5,0.1c-0.5,0.1-1-0.4-1.6-1.2l-0.1-0.2c0,0,0-0.1-0.1-0.1l-0.1-0.2c0,0,0-0.1-0.1-0.1 l-0.1-0.2l0,0l-0.1-0.2l0,0l-0.1-0.2l0,0l-0.2-0.4l0,0l-0.1-0.3l0,0l-0.2-0.4l0,0l-0.3-0.6l0,0l-0.9-2 C66.7-285.5,65.7-287,64.7-288.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st2",
    d: "M65.9-286.6l1.2-0.3c0.3,0.3,0.7,0.6,1,1l-1.5,0.4C66.3-285.9,66.1-286.3,65.9-286.6z  M67.5-283.8c-0.1-0.2-0.2-0.4-0.3-0.7L69-285c0.3,0.3,0.5,0.7,0.8,1l-2.1,0.6L67.5-283.8z M68.6-281.3l-0.3-0.6l-0.2-0.4 l2.3-0.6c0.2,0.3,0.4,0.7,0.6,1.1l-2.4,0.7V-281.3z M69.7-279.2L69.7-279.2l-0.2-0.3l0,0l-0.1-0.3l-0.1-0.2l2.5-0.7 c0.1,0.2,0.2,0.4,0.4,0.7l0.2,0.4l-2.5,0.7L69.7-279.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000163052341578426675690000013855552601100823733_",
    className: "st6",
    d: "M82.5-277.6c-1.8-3.6-4.3-7.2-7.5-10.8 l0.2,0.3c2.8,1.8,5.7,3.7,8.7,5.9C83.9-280.3,83.5-278.8,82.5-277.6c0.1,0.1,0,0.1,0,0.2V-277.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_00000074436883646585169760000005101203201177063829_",
    className: "st7",
    d: "M78.6-286.7 c-0.3-0.2-0.4-0.5-0.2-0.8c0.2-0.3,0.5-0.4,0.8-0.2l3.5,1.9l0,0c0.3,0.2,0.4,0.5,0.2,0.8c-0.2,0.3-0.5,0.4-0.8,0.2L78.6-286.7 L78.6-286.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000084531095799037402040000009198577223577239196_",
    className: "st7",
    d: "M71.2-290.5c2.7,1.5,5.4,3.2,8.3,5.2 c0,0-0.1,0-0.1,0.1l-0.2,0.1h-0.1l-0.2,0.1l0,0l-0.2,0.1c-1.3,0.5-3.3,0.7-5.3-0.7C71.8-286.9,71-288.5,71.2-290.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path-110",
    className: "st5",
    d: "M-76.6,56.7l-16.1,29.9c-2.3-2-4.8-3.8-7.4-5.3c-2.6-1.6-6.4-3.5-11.5-5.9L-96,39.9 L-76.6,56.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 32.472389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4_00000153692538497126598770000004902327803025145254_",
    className: "st4",
    d: "M-57.5,40.2L-66.2,29l-17.9,9.9l0,0 l11.8,9.5c3.5,2.8,6.6,6.2,9.1,9.9L-43,88.2l7.5-4.5l0,0l-17.4-35.8C-54.1,45.2-55.7,42.6-57.5,40.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(14.925084, 55.696162) rotate(25.000000) translate(-14.925084, -55.696162) translate(1.807485, 48.500092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-26_00000030484782737872198310000015467092874523470735_",
    className: "st2",
    d: "M-8.8,45.1 c-8.2,11-12.4,17.2-12.7,18.4c-0.4,1.9,1,2.8,1.8,3s1.5-0.3,2.9-2.5c1.4-2.2,10.2-16.8,10.5-17.4c0.3-0.6,0.6-1.1,0.2-1.4 C-6.3,45-6.7,45-7,45.2L-8.8,45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-25_00000177458374932301434220000004258572036206886304_",
    className: "st5",
    d: "M-28.5,59.4L-28.5,59.4 c0.6,1.4,1.4,2.6,2.4,3.5c1.1,0.9,2.6,1.5,4.4,1.7c6.2-6.9,11-13.4,14.5-19.4c-1-1.9-2.2-1.9-3.6-1.1c-1.4,0.8-4,2.9-7.6,4.1 s-6.5,2.1-6.4,3.3c0.1,1.2,0.8,3.3,0,4.7c-0.5,0.9-1.7,1.7-3.6,2.6C-28.5,59-28.6,59.2-28.5,59.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000014598092227601866380000004931757562798194324_",
    className: "st6",
    d: "M-24.4,50.8c1.5,1.9,1.7,3.9,0.6,5.8 c-0.8,1.6-2.4,2.6-4.6,3l0,0v-0.1l-0.1-0.2l0,0c-0.1-0.2,0-0.4,0.2-0.5c1.9-0.9,3.1-1.7,3.6-2.6c0.5-0.9,0.4-2,0.2-3v-0.3l0,0 l-0.1-0.6l0,0V52c0-0.2-0.1-0.4-0.1-0.6C-24.7,51.3-24.6,51.1-24.4,50.8L-24.4,50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000160897382151733088320000002694623605200523697_",
    className: "st6",
    d: "M-13.6,46c-0.7,1.7-2.5,3.3-5.4,4.8 l-0.4,0.2c-0.9,0.5-2,1-3.2,1.4l-0.5,0.2c-0.1,0-0.2,0.1-0.2,0.1l-0.5,0.2c-0.2,0.1-0.5,0.2-0.8,0.3c0-0.1,0-0.1,0-0.2 l-0.1-0.7l0,0l-0.1-0.3c0-0.2-0.1-0.4-0.1-0.6c0-0.5,0.5-1,1.4-1.4l0.2-0.1h0.1l0.2-0.1h0.1l0.2-0.1l0,0l0.2-0.1l0,0l0.2-0.1 l0,0l0.4-0.1l0,0l0.3-0.1l0,0l0.4-0.1l0,0l0.6-0.2l0,0l2-0.7C-16.5,47.7-14.9,46.8-13.6,46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000162314516424413269130000000123564501431544254_",
    className: "st2",
    d: "M-15.3,47l0.2,1.2 c-0.3,0.3-0.7,0.6-1.1,0.9l-0.2-1.6C-16.1,47.4-15.7,47.2-15.3,47z M-18.3,48.3c0.2-0.1,0.5-0.2,0.7-0.2l0.3,1.9 c-0.3,0.2-0.7,0.4-1.1,0.7l-0.3-2.1L-18.3,48.3z M-20.9,49.2l0.6-0.2l0.4-0.1l0.4,2.3c-0.4,0.2-0.7,0.4-1.1,0.5l-0.4-2.5 H-20.9z M-23.1,50L-23.1,50l0.3-0.1l0,0l0.3-0.1l0.3-0.1l0.4,2.6c-0.2,0.1-0.5,0.2-0.7,0.3l-0.4,0.2l-0.4-2.5L-23.1,50z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000093884644396242171200000004276942696525076668_",
    className: "st6",
    d: "M-26,62.6c3.8-1.4,7.6-3.5,11.5-6.3 l-0.3,0.2c-2,2.6-4.3,5.3-6.8,8.1c-1.9-0.2-3.3-0.8-4.4-1.7c-0.1,0-0.1-0.1-0.2-0.2L-26,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_00000033369516922498885910000010823490380185035967_",
    className: "st7",
    d: "M-16.5,59.7 c0.2-0.3,0.6-0.3,0.8-0.1c0.3,0.2,0.3,0.6,0.1,0.8l-2.3,3.2l0,0c-0.2,0.3-0.6,0.3-0.8,0.1c-0.3-0.2-0.3-0.6-0.1-0.8 L-16.5,59.7L-16.5,59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000148654827986085132190000001576756231949384866_",
    className: "st7",
    d: "M-12,52.7c-1.8,2.5-3.8,5.1-6,7.7 c0-0.1,0-0.1-0.1-0.2l-0.1-0.2v-0.1l-0.1-0.2l0,0v-0.2c-0.3-1.4-0.3-3.3,1.2-5.2C-15.6,52.9-14,52.3-12,52.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000154403072420764847420000016033054539304644784_",
    className: "st8",
    d: "M-80.6,63.9l-6,10.9 c-12.7-9.7-17.6-18.2-14.7-25.4L-80.6,63.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-109",
    className: "st9",
    d: "M-80.2,39.7v3.5l20.5,25.2c-3.5,2-6.5,4.1-9,6.4c-1.4,1.3-2.9,3.4-4.6,6.5 c-2.6-2.2-7.9-6.9-15.9-14.3c-12.5-6.9-17.3-14.8-14.2-23.8l0.2-3.5H-80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000134941882521354441360000009146227728479932324_",
    className: "st8",
    d: "M-80.2,39.7v3.5l0,0c-3.9,1.4-8,2-12.4,2 c-4.2,0-7.7-0.7-10.7-2.1l0.2-3.5L-80.2,39.7L-80.2,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    className: "st10",
    d: "M-94.5,43.4c0,14.5,18.4,23.7,24.9,31.9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-3",
    className: "st11",
    x1: -97.3,
    y1: 62.1,
    x2: -104.3,
    y2: 78.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-103",
    className: "st4",
    d: "M-116.5,74.6l1.6-1l-3.8-9.9l0,0l-4.8,2.8c-1.5,0.9-2.7,2.4-3.1,4.1c-0.5,1.8-0.4,3.6,0.1,5.4 l6.7,22l0,0l-0.7,9.3c0,0.1,0,0.2,0,0.3l-0.1,1.6l0,0c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.3-0.1,0.4-0.3l0.1-0.4 c0.1-0.5,0.2-0.9,0.3-1.4l0.3-1.4l0,0v1.6c0,0.7,0,1.3,0.1,2l0.1,1.8c0,0.2,0.2,0.4,0.5,0.4c0.2,0,0.4-0.2,0.4-0.4v-1.2 c0-1.1,0.1-2.2,0.2-3.2l0.1-1l0,0l0.1,2.5v0.1l0.2,3.6c0,0.3,0.3,0.5,0.6,0.5c0.3,0,0.5-0.2,0.5-0.5v-1.6c0-1.4,0.1-2.8,0.3-4.2 l0.1-0.4l0,0v0.5c0,1.3,0.1,2.5,0.2,3.8l0.2,1.5l0,0c0,0.3,0.3,0.5,0.6,0.4c0.3,0,0.5-0.3,0.5-0.6c0.1-2.4,0.1-4,0.1-4.8 c0-0.9,0.2-2.3,0.7-4.3c0.2,0.7,0.5,1.5,0.8,2.5s1,1.5,2.2,1.5c-0.6-1.8-0.9-3.7-0.9-5.7c0-2.1-0.8-3.7-2.5-4.9L-116.5,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000000917101440563325360000005570154973490846895_",
    className: "st12",
    d: "M-118.1,65.3l3.2,8.4l-1.6,1l0.2,2.1 c-0.4-0.5-0.7-1-1-1.5l-0.3-0.4c-2.5-3.8-3.7-7-3.6-9.5l1.1-0.6L-118.1,65.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(21.649798, 20.391923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-96",
    className: "st4",
    d: "M-86.9,56.5l-1-1.7l-8.5,6.3l0,0l2.6,4c1.2,1.7,2.9,3,5,3.5h0.2c1.9,0.5,3.9,0.1,5.6-0.9 c1.7-1.1,3.3-2.4,4.5-4l11.9-15.5c1.9,0,3-1.7,3.4-5.1c0.2-1.5,0.6-3,1.3-4.3l1.4-2.8c0.1-0.3,0.1-0.6-0.2-0.7l0,0 c-0.2-0.1-0.5-0.1-0.6,0.1l-2.3,3.7l0,0l2.1-7.2c0.1-0.3-0.1-0.7-0.4-0.8l0,0c-0.3-0.1-0.6,0-0.8,0.3l-2.4,6.1l0,0l0.8-7.5 c0-0.3-0.2-0.7-0.5-0.8c0,0,0,0-0.1,0c-0.3-0.1-0.6,0.1-0.6,0.4l-1.6,7l0,0v-6.7c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5l-1,9.8 c-0.3-1.9-0.6-3.2-0.9-3.9s-0.9-1-1.7-1c0.4,1.9,0.5,3.5,0.4,4.8c-0.2,1.3-0.1,2.6,0.2,4L-86.9,56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000090280239737687178540000016882531375942189722_",
    className: "st12",
    d: "M-87.4,55.7c-1.9,2.6-4.5,5-7.8,7.1 l-1.2-1.7l4.9-3.6l4-1.9L-87.4,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-97",
    className: "st13",
    d: "M-67.8,46.4c1.4-2.4,1-4.8-1.2-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-98",
    className: "st13",
    d: "M-67.8,37.8c1.7,0.3,3.2,1,4.5,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-99",
    className: "st13",
    d: "M-64.3,42.6c-0.7-1.2-2.2-2.3-4.5-3.3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-100",
    className: "st13",
    x1: -67,
    y1: 34.2,
    x2: -67.1,
    y2: 38
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-101",
    className: "st13",
    x1: -64.6,
    y1: 34,
    x2: -65.1,
    y2: 38.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-102",
    className: "st13",
    x1: -63.8,
    y1: 39.6,
    x2: -62.9,
    y2: 36.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-108",
    className: "st13",
    x1: -89.5,
    y1: 58.4,
    x2: -86.5,
    y2: 56.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(47.927370, 25.088964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-95",
    className: "st14",
    d: "M-126.1,53.5c-0.4,4.8-0.3,8.2,0.5,10.2c0.8,2-0.1,3.3-2.6,3.8c-2,1.4-6,2.1-11.9,2.1 c-7,0-11.2-0.7-12.7-2.1c-1.9-0.6-2.5-2.3-1-6.9c1-3,0.8-7.6-0.5-13.7l-9.5,3.8c-1-1.5-2-3.2-3.1-5.2s-1.9-4.1-2.6-6.3l0,0 l11.9-6.7c1.9-1,3.8-1.9,5.9-2.6c2-0.7,4.2-0.9,6.3-0.8l15.7,1.2c2,0.1,3.9,0.9,5.5,2.1s3,2.7,4,4.5l7.5,13.4 c-1.9,1.8-3.7,3.3-5.2,4.3s-3.3,2.1-5.2,3.2L-126.1,53.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000079468586912707049790000011776257463469252025_",
    className: "st15",
    d: "M-114,48.2l0.4,0.7 c-0.8,0.8-1.7,1.5-2.6,2.3c-2.4,2-5,3.7-7.9,5.3l0,0l-0.4-0.6c2.8-1.6,5.4-3.3,7.8-5.3C-115.8,49.8-114.9,49-114,48.2z  M-115,46.4l0.4,0.7c-0.9,0.8-1.8,1.6-2.7,2.4c-2.4,2-5,3.7-7.9,5.3l0,0l-0.4-0.6c2.8-1.6,5.4-3.3,7.8-5.3 C-116.9,48.1-115.9,47.2-115,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000065053130874216119110000012890389187965078938_",
    className: "st15",
    d: "M-164.8,43.9c1,2.1,2.2,4,3.5,5.9 l-0.7,0.3c-1.3-1.9-2.4-3.8-3.5-5.9c-0.9-1.9-1.8-3.8-2.5-5.8l0.7-0.4C-166.6,40.1-165.8,42-164.8,43.9z M-162.9,43.1 c1,2.1,2.2,4,3.5,5.9l-0.7,0.3c-1.3-1.9-2.4-3.8-3.5-5.9c-1-1.9-1.8-3.9-2.6-6l0.7-0.4C-164.8,39.1-163.9,41.2-162.9,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000145032355506310846140000014171691108530093697_",
    className: "st16",
    d: "M-121.1,56.7c-0.5,0.3-1.2,0.7-2.1,1.2 l-2.9-4.4c-0.1,0.7-0.1,1.4-0.2,2.1c-0.1-0.4-0.1-0.8-0.1-1.2v-9.2l6.5,10.7C-120.2,56.1-120.6,56.4-121.1,56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000097479325914963879870000001634600387268552378_",
    className: "st5",
    d: "M-150,45.8L-150,45.8l-0.1,0.6l0,0 l-0.1,0.6l0,0l-0.1,0.6l0,0l-0.1,0.9l0,0l-0.1,0.6l0,0l-0.1,0.6l0,0l-0.1,0.5l0,0l-0.1,0.5l0,0l-0.1,0.5l0,0l-0.1,0.5l0,0 l-0.1,0.5l0,0l-0.1,0.5l0,0l-0.1,0.5l0,0l-0.1,0.5l0,0l-0.1,0.5l0,0l-0.1,0.5l0,0l-0.1,0.4l0,0l-0.1,0.4l0,0l-0.1,0.4l0,0 l-0.1,0.4c0,0.1-0.1,0.3-0.1,0.4l0.1,0.3l0,0l-0.1,0.4l0,0l-0.1,0.4l0,0l-0.1,0.4l0,0l-0.1,0.4c0,0.1-0.1,0.2-0.1,0.3l-0.1,0.3 c-0.1,0.3-0.2,0.5-0.3,0.8l-0.1,0.3l0,0l-0.1,0.3c-0.2,0.5-0.4,0.9-0.7,1.3l-0.1,0.2c-0.1,0.2-0.3,0.5-0.4,0.7 c0.1-0.6,0.3-1.4,0.6-2.2v-0.2c0.8-2.7,0.8-6.5-0.1-11.5l-0.1-0.6l0,0l-0.1-0.6l0,0l-0.1-0.6l0,0l-0.1-0.3l-1,0.3l0,0V47 l5.4-2.1L-150,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-111",
    className: "st17",
    d: "M-126.4,54.4c0-2.8,0-5.9,0-9.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(71.103376, 14.556717) scale(-1, 1) rotate(7.000000) translate(-71.103376, -14.556717) translate(62.405177, 0.960335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-60",
    className: "st18",
    d: "M175,27.7c0.7-0.1,1.5-2.5,2.1-7.3c1.2-4.8,0.1-7-3.3-6.7c-0.5-2.7-3.2-1.9-5-1.9 c-1.8,0-1.9-1.3-3.4-1.5c-1-0.2-1.2,0.6-0.5,2.2c-1.7-0.2-2.4,0.3-2.2,1.5c-3.1,0.5-3.4,3.4-2.2,4.6c0.8,0.8,1.9,1.2,3.1,1.1 C170.4,25.1,174.2,27.8,175,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-55",
    className: "st4",
    d: "M166.2,19.1c1.3-0.3,2.9-1,5-2.1c0.3,1.2,0.9,2.1,1.7,2.8c0.3,0.2,0.5,0.6,0.5,1l0.2,1.9l0,0 c0,0.1,0.2,0.2,0.3,0.2c0.2,0,0.3-0.2,0.4-0.4c0.4-2,1.1-2.9,2-2.8c1.4,0.3,1.5,1.8,0.8,3.3c-0.4,1.1-1.2,1.7-2.3,2.1l2.2,8.7 c-1.3,1.2-2.7,2-4.1,2.4c-1.4,0.3-2.8,0.2-4.1-0.3l-1.1-4.6l0,0l0,0c-0.6,0.1-1.1-0.1-1.6-0.4l-0.2-0.1c-0.6-0.4-1-1-1.2-1.7 l-2.2-9.6C163.7,19.6,164.9,19.4,166.2,19.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(11.948425, 13.530215) scale(-1, 1) rotate(11.000000) translate(-11.948425, -13.530215) translate(8.364889, 9.767551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    className: "st18",
    d: "M-147.4,44.4c0.3,0.8,1.6,0.7,1.5-0.4c-0.1-0.7-0.5-1.5-1.3-2.4 C-147.5,42.9-147.6,43.8-147.4,44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    className: "st5",
    d: "M-148.7,42.3c0-0.3-0.2-0.5-0.3-0.5c-0.2,0-0.3,0.2-0.3,0.5s0.2,0.5,0.3,0.5 C-148.8,42.8-148.7,42.5-148.7,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy",
    className: "st5",
    d: "M-144.4,42.6c0-0.3-0.2-0.5-0.3-0.5c-0.2,0-0.3,0.2-0.3,0.5s0.2,0.5,0.3,0.5 C-144.5,43.1-144.4,42.9-144.4,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    className: "st19",
    d: "M-146.1,40.4c1.1-0.4,2-0.3,2.7,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-12",
    className: "st19",
    d: "M-150.7,40.5c0.9-0.6,1.8-0.7,2.7-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-14",
    className: "st20",
    d: "M-146.2,47c-1.5,0.4-2.6-0.1-3.3-1.2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-61",
    className: "st21",
    d: "M161.2,19c3,1.6,6.7,0.7,10.9-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-62",
    className: "st18",
    d: "M171.3,32.8c-0.8,1.2-1.7,2-2.6,2.5l-1-3.9c2.2-0.3,3.8-1,4.8-2.4 C172.5,30.4,172.1,31.6,171.3,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-63",
    className: "st20",
    d: "M175.4,24.2c-0.6-1.2-0.4-2.4,0.8-3.6"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-64",
    className: "st20",
    x1: 176.3,
    y1: 22.7,
    x2: 175.1,
    y2: 23.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-112",
    className: "st22",
    d: "M-94.2,54.8c3.7,2.6,7.1,2.9,10,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-105",
    className: "st13",
    d: "M-116.2,107.7c0-0.6,0.1-1.8,0.3-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-106",
    className: "st13",
    d: "M-117.9,107.6c0-1.9,0.2-3.6,0.2-3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-107",
    className: "st13",
    d: "M-119.4,107.3c0.1-1.2,0.2-2.3,0.4-3.3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy_00000070806424185806936450000016387929577168880774_",
    transform: "translate(42.460685, 34.521307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-11",
    className: "st23",
    d: "M443.8,34.9v64.8c0,1.6-1.3,2.9-2.9,2.9h-99.6c-1.6,0-2.9-1.3-2.9-2.9V34.9 c0-1.6,1.3-2.9,2.9-2.9h99.6C442.5,32,443.8,33.3,443.8,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_00000083787458860951841220000008101458895058198939_",
    className: "st2",
    d: "M446.8,31.9v64.8c0,1.6-1.3,2.9-2.9,2.9 h-99.6c-1.6,0-2.9-1.3-2.9-2.9V31.9c0-1.6,1.3-2.9,2.9-2.9h99.6C445.5,29,446.8,30.3,446.8,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-7_00000111887970544486075840000009296345622847255461_",
    className: "st24",
    d: "M441.7,36.3v56.9 c0,1.3-1,2.3-2.3,2.3h-90.5c-1.3,0-2.3-1-2.3-2.3V36.3c0-1.3,1-2.3,2.3-2.3h90.5C440.6,34,441.7,35.1,441.7,36.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5_00000021096435231774708920000011865724950647872934_",
    transform: "translate(25.598158, 12.597061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-5",
    className: "st2",
    d: "M366.1,36.9c0,4.4-3.5,7.9-7.9,7.9c-4.3,0-7.9-3.5-7.9-7.9s3.5-7.9,7.9-7.9 C362.6,29,366.1,32.5,366.1,36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-4",
    className: "st2",
    d: "M341.8,71.1l8.6-12.3c1.2-1.8,3.5-2,5-0.4l3.3,3.4c1.5,1.6,3.8,1.4,5.2-0.3l13.6-17.8 c1.3-1.7,3.2-1.6,4.2,0.4l13.5,26.8c1,1.9,0,3.5-2.2,3.5h-24.2h-25.3C341.3,74.3,340.6,72.9,341.8,71.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-2",
    transform: "translate(230.286772, 44.527483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-11_00000034084187145425376720000007712738573909603245_",
    className: "st23",
    d: "M69.4,32.5v38.8 c0,1-0.8,1.7-1.7,1.7H7.9c-1,0-1.7-0.8-1.7-1.7V32.5c0-1,0.8-1.7,1.7-1.7h59.7C68.6,30.8,69.4,31.6,69.4,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_00000151525903380312314120000002146145420405564558_",
    className: "st2",
    d: "M71.1,30.7v38.8c0,1-0.8,1.7-1.7,1.7 H9.7c-1,0-1.7-0.8-1.7-1.7V30.7c0-1,0.8-1.7,1.7-1.7h59.7C70.4,29,71.1,29.8,71.1,30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-7_00000182495477683983500560000002678451570555013289_",
    className: "st24",
    d: "M68.1,33.4v34.1 c0,0.8-0.6,1.4-1.4,1.4H12.5c-0.8,0-1.4-0.6-1.4-1.4V33.4c0-0.8,0.6-1.4,1.4-1.4h54.2C67.4,32,68.1,32.6,68.1,33.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5_00000003068253219747061790000014640035928474697094_",
    transform: "translate(15.335302, 7.541098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-5_00000119827347795230592780000015170945417669458053_",
    className: "st2",
    d: "M22.8,33.7c0,2.6-2.1,4.7-4.7,4.7 s-4.7-2.1-4.7-4.7s2.1-4.7,4.7-4.7S22.8,31.1,22.8,33.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-4_00000025409973210972321120000009185189944642236601_",
    className: "st2",
    d: "M8.3,54.2l5.2-7.4 c0.7-1.1,2.1-1.2,3-0.3l2,2c0.9,0.9,2.3,0.8,3.1-0.2l8.1-10.7c0.8-1,1.9-0.9,2.5,0.2l8,16.2c0.6,1.2,0,2.1-1.3,2.1H24.4H9.3 C8,56.1,7.5,55.3,8.3,54.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-3",
    transform: "translate(42.460685, 328.202573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-11_00000045595082411600970310000015264401941649849991_",
    className: "st23",
    d: "M445,32.5v38.8 c0,1-0.8,1.7-1.7,1.7h-59.7c-1,0-1.7-0.8-1.7-1.7V32.5c0-1,0.8-1.7,1.7-1.7h59.7C444.2,30.8,445,31.6,445,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_00000091004456667649728690000013037845203784370318_",
    className: "st2",
    d: "M446.8,30.7v38.8c0,1-0.8,1.7-1.7,1.7 h-59.7c-1,0-1.7-0.8-1.7-1.7V30.7c0-1,0.8-1.7,1.7-1.7h59.7C446,29,446.8,29.8,446.8,30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-7_00000165225870560689248040000017780729899458709903_",
    className: "st24",
    d: "M443.7,33.4v34.1 c0,0.8-0.6,1.4-1.4,1.4h-54.2c-0.8,0-1.4-0.6-1.4-1.4V33.4c0-0.8,0.6-1.4,1.4-1.4h54.2C443.1,32,443.7,32.6,443.7,33.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5_00000036937134639360270590000007429930203460995996_",
    transform: "translate(15.335302, 7.541098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-5_00000028323274127922108730000012344200503056221111_",
    className: "st2",
    d: "M398.5,33.7c0,2.6-2.1,4.7-4.7,4.7 s-4.7-2.1-4.7-4.7s2.1-4.7,4.7-4.7S398.5,31.1,398.5,33.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-4_00000142166603371484194490000003713170034252412591_",
    className: "st2",
    d: "M383.9,54.2l5.2-7.4 c0.7-1.1,2.1-1.2,3-0.3l2,2c0.9,0.9,2.3,0.8,3.1-0.2l8.1-10.7c0.8-1,1.9-0.9,2.5,0.2l8.1,16.1c0.6,1.2,0,2.1-1.3,2.1h-14.5h-15.2 C383.6,56.1,383.2,55.3,383.9,54.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path-30",
    className: "st25",
    d: "M369.5,98.5l-4.4,1.4c-2.1,0.7-3.7,2.3-4.3,4.4l-1.3,4.4l0,0l-1.3-4.5c-0.6-2.1-2.2-3.7-4.3-4.4 l-4.4-1.4l0,0l4-0.9c2.3-0.5,4.1-2.3,4.8-4.5l1.2-4.3l0,0l1.5,4.6c0.7,2.1,2.5,3.8,4.7,4.3L369.5,98.5L369.5,98.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6_00000112628162147988767280000006046921439824989111_",
    transform: "translate(339.167438, 288.678178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-11_00000165198306571180812830000009579054318155992710_",
    className: "st23",
    d: "M-151.6,38.8v108 c0,2.7-2.1,4.8-4.8,4.8h-166.2c-2.7,0-4.8-2.1-4.8-4.8v-108c0-2.7,2.1-4.8,4.8-4.8h166.2C-153.8,34-151.6,36.2-151.6,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_00000173855331886738541200000012951039825519398072_",
    className: "st2",
    d: "M-146.6,33.8v108c0,2.7-2.1,4.8-4.8,4.8 h-166.2c-2.7,0-4.8-2.1-4.8-4.8v-108c0-2.7,2.1-4.8,4.8-4.8h166.2C-148.8,29-146.6,31.1-146.6,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-7_00000142166675073575046020000011600659087543755694_",
    className: "st24",
    d: "M-155.2,41.2v94.9 c0,2.1-1.7,3.8-3.8,3.8h-151c-2.1,0-3.8-1.7-3.8-3.8V41.2c0-2.1,1.7-3.8,3.8-3.8h151C-156.9,37.4-155.2,39.1-155.2,41.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5_00000070833283703209821370000017201954262335655061_",
    transform: "translate(42.702918, 20.995101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-5_00000029023798544958913630000013739905058859887281_",
    className: "st2",
    d: "M-281.2,42.2 c0,7.3-5.9,13.2-13.1,13.2c-7.3,0-13.1-5.9-13.1-13.2s5.9-13.2,13.1-13.2C-287,29-281.2,34.9-281.2,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-4_00000086688926522237943360000012359387731455037850_",
    className: "st2",
    d: "M-321.7,99.2l14.4-20.5 c2.1-3,5.8-3.3,8.4-0.7l5.5,5.6c2.6,2.6,6.4,2.3,8.6-0.5l22.7-29.7c2.2-2.9,5.3-2.6,7,0.6l22.5,44.7c1.6,3.2,0,5.9-3.6,5.9h-40.4 h-42.3C-322.6,104.6-323.8,102.2-321.7,99.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path-30-Copy",
    className: "st25",
    d: "M210.3,329.5l-1.5,0.5c-2.1,0.7-3.7,2.3-4.3,4.4l-0.4,1.5l0,0l-0.5-1.6 c-0.6-2.1-2.2-3.7-4.3-4.4l-1.5-0.5l0,0l1.1-0.2c2.3-0.5,4.1-2.3,4.8-4.5l0.4-1.3l0,0l0.5,1.6c0.7,2.1,2.5,3.8,4.7,4.3L210.3,329.5 L210.3,329.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-30-Copy-2",
    className: "st25",
    d: "M197.4,63.9l-1.5,0.5c-2.1,0.7-3.7,2.3-4.3,4.4l-0.4,1.5l0,0l-0.5-1.6 c-0.6-2.1-2.2-3.7-4.3-4.4l-1.5-0.5l0,0l1.1-0.2c2.3-0.5,4.1-2.3,4.8-4.5l0.4-1.3l0,0l0.5,1.6c0.7,2.1,2.5,3.8,4.7,4.3L197.4,63.9 L197.4,63.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-30-Copy-3",
    className: "st25",
    d: "M226.1,76.1H226c-2.1,0.7-3.7,2.3-4.3,4.4v0.1l0,0l-0.1-0.2c-0.6-2.1-2.2-3.7-4.3-4.4 l-0.2-0.1l0,0l0,0c2.1-0.5,3.9-2.1,4.5-4.2l0.1-0.2l0,0l0.1,0.4C222.4,74.1,224,75.7,226.1,76.1L226.1,76.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M425,180.4c11.4-17.5,0.2-26-13.9-12.8l-12.6,14.9v43.4L425,180.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M424,235.5c11-16.7,0.1-25.9-13.9-12.8l-12.6,14.9V281L424,235.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M425,280.2c10.4-16.7-0.4-22-13.9-8.7l-12.6,14.9v39.2L425,280.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "403.3,176.9 400.2,223 411.1,204.5 404.7,175.2 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "405.9,227.6 403,231.1 400.2,273.1 404.3,269.3 411.7,256.6 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "406.4,277.2 402.9,281.3 400.2,321.5 401.9,320 412.3,302.4 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M332,479.5l-90.6-0.4L239.7,369c0,0,11.7-92.7,13.3-93.6c1.6-0.8,31.6-54.9,31.6-54.9s109,125.6,111.5,126.4 c1.9,1.4-39.6,35-64.1,64.6V479.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M262.1,391.7l69.9,43.9v-24.1c5.9-7.1,12.7-14.3,19.6-21.4L262.1,391.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M282.9,294.3l-31-26l3.6-39.3c3.4-17-13.6-30-20.2-9.7c-5.4,14.1-13.1,33.4-12.5,51.5 c3.1,16.5,14,120,29.6,131.5l90.1-39.4L282.9,294.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M275.2,260.5c5.5,16.5,29.8,5.9,25.1-5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M387.6,118.3H269.3c-9,0-16.3,7.4-16.3,16.5v243.9c0,9.1,7.3,16.5,16.3,16.5h118.3c9,0,16.3-7.4,16.3-16.5 V134.8C403.9,125.7,396.6,118.3,387.6,118.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M387.2,242.6c-7.7-9.2-14.3-7-17.9-33c-1.8-24.7-25.8-35.6-34.8-28.9c-10.5-8.2-41,0.3-44.5,27 c-1.9,22.9-9.9,23.2-25.9,34.9c-24.6,20.2-7.3,54.5,19.3,52.3c0.1,0,91.5,0,91.5,0l0,0C410.3,293.7,411.7,263.6,387.2,242.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M403.6,272.9l0.1-0.1c-11.9,18.2-55.1,16.5-52.3-41.5l-13.9-42.8c-6.5,3.9-13.2,10.9-26.5,15.8 c-22.9,6.9-8.9,29.5-7.9,53.6c-3.6,26.8-27.2,23.5-48.4,18.9c3.6,11.2,12.2,19.5,28.8,18.1c0.1,0,91.5,0,91.5,0l0,0 C398.1,294.1,404.3,284.8,403.6,272.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M255.8,378.3c0.2,0.3,0.3,0.5,0.5,0.5h145.5v-71.5c-14.3-12-41.4-20.1-72.4-20.1c-31.9,0-59.6,8.5-73.6,21 L255.8,378.3L255.8,378.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M358.8,247.9c-0.2,3-2.8,5.3-5.9,5.1c-3-0.2-5.3-2.8-5.1-5.9c0.2-3,2.8-5.3,5.9-5.1 C356.7,242.3,359,244.9,358.8,247.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M344.2,287.8c-9.9,6.6-19.3,5.5-28.5,0.1l2.8-29h23L344.2,287.8z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "343.4,278 341.5,258.8 318.5,258.8 317.6,267.1 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M355.4,230.4c2.6-20.9-7.5-24.1-17.7-40.1c-0.1-0.2-0.2-0.3-0.3-0.5c-15.6,33.3-34,9.7-34.3,41.3 c3.9,18.5,12.9,33.7,26.4,36c3.8,1.2,14.9-6.5,20.5-14.9C354,245,355.3,237.2,355.4,230.4z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M300,243.2c1.2,2.6,4.5,3.3,7,1.9l0,0c3.9-1.2,4.6-5.3,3.8-6.7l-4.7-11c-1.2-2.6-4.5-3.4-7.3-2.2h0.1 c-3.2,1.6-4.7,4.4-3.5,7L300,243.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M308.4,247.9c-0.2,3-2.8,5.3-5.9,5.1c-3-0.2-5.3-2.8-5.1-5.9c0.2-3,2.8-5.3,5.9-5.1 C306.3,242.3,308.6,244.9,308.4,247.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M328.8,241c7.6-0.3,4.3-5.9,3.4-13.4l-1.6-9.9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M335.7,249.5c-3.1,3.1-7.1,3.8-11.1,0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st35",
    x1: 309.1,
    y1: 221.1,
    x2: 316,
    y2: 221.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M310.3,229c1.2-0.4,2.4-0.5,3.8-0.2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st35",
    x1: 342.8,
    y1: 221.1,
    x2: 349.7,
    y2: 221.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M344,229c1.2-0.4,2.4-0.5,3.8-0.2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M388.8,115H268.1c-9.2,0-16.7,7.5-16.7,16.7v246.9c0,9.2,7.5,16.7,16.7,16.7h120.7c9.2,0,16.7-7.5,16.7-16.7 v-247C405.5,122.4,398,115,388.8,115z M400.2,361.7c0,8-7.1,14.2-15.6,14.2H272.3c-8.5,0-16-6.2-16-14.2V135.4c0-8,7.5-13.4,16-13.4 h17.1v3.7c0,2.2,3.5,3.8,5.8,3.8h66.7c2.2,0,3.9-1.6,3.9-3.8V122h0.1h18.7c8.5,0,15.6,5.4,15.6,13.4L400.2,361.7L400.2,361.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M231.3,235.9c1.8,0,3.6-1,5.4-3c2.2-2.6,3.9-6.3,4.5-10.2c0.6-4.1-0.1-7.8-2-10.6c-0.4,0.4-0.7,0.9-1.1,1.4 c3.4,5.5,0.9,14.1-2.7,18.2c-0.9,1-3.1,3.2-5.4,2.1c-0.2,0.5-0.4,1.1-0.5,1.6C230.1,235.8,230.7,235.9,231.3,235.9z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M326.9,217.7c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C326.4,216.5,326.9,217,326.9,217.7L326.9,217.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M318.7,226.6c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C318.2,225.5,318.7,226,318.7,226.6L318.7,226.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M335.5,217.7c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C335,216.5,335.5,217,335.5,217.7L335.5,217.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M340.3,227c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C339.8,225.9,340.3,226.4,340.3,227L340.3,227z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M338.1,239.3c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C337.6,238.2,338.1,238.7,338.1,239.3L338.1,239.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M326.5,240.4c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C326,239.3,326.5,239.8,326.5,240.4L326.5,240.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M332.1,256.8c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C331.6,255.7,332.1,256.2,332.1,256.8L332.1,256.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M332.1,268.8c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C331.6,267.7,332.1,268.2,332.1,268.8L332.1,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M321.3,250.5c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C320.8,249.4,321.3,249.9,321.3,250.5L321.3,250.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M340.7,250.5c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C340.2,249.4,340.7,249.9,340.7,250.5L340.7,250.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M356.4,230.3c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C355.9,229.2,356.4,229.7,356.4,230.3L356.4,230.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M303.4,226.6c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C302.9,225.5,303.4,226,303.4,226.6L303.4,226.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M307.1,241.5c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C306.6,240.4,307.1,240.9,307.1,241.5L307.1,241.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M316.1,258c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C315.6,256.8,316.1,257.3,316.1,258L316.1,258z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M347.1,258c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C346.5,256.8,347.1,257.3,347.1,258L347.1,258z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M356,215.4c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C355.5,214.3,356,214.8,356,215.4L356,215.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M338.8,194.5c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C338.3,193.4,338.8,193.9,338.8,194.5L338.8,194.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M309,213.6c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0 C308.5,212.4,309,212.9,309,213.6L309,213.6z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st40",
    points: "337.7,194.5 354.9,215.4 334.4,217.7 337.7,195.6 325.8,217.7 307.9,213.6 336.6,194.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st40",
    points: "306.7,213.6 301.5,225.7 306,241.5 315,259.1 329.9,268.8 344.8,258 355.3,230.3 354.9,215.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st40",
    points: "334.4,218.8 339.2,227 337,239.3 339.6,250.5 355.3,230.3 338.1,239.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st40",
    points: "331,268.8 339.6,251.6 331,258 329.9,268.8 320.2,251.6 329.9,256.8  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st40",
    x1: 315,
    y1: 258,
    x2: 320.2,
    y2: 251.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st40",
    x1: 339.6,
    y1: 250.5,
    x2: 345.9,
    y2: 258
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st40",
    points: "302.3,227.7 324.3,240.4 306,241.5 320.2,249.4 325.4,240.4 318.7,226.6 325.8,218.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st40",
    points: "325.4,240.4 325.8,217.7 333.2,217.7  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st40",
    x1: 320.2,
    y1: 250.5,
    x2: 337,
    y2: 240.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st40",
    x1: 325.4,
    y1: 241.5,
    x2: 338.5,
    y2: 250.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st41",
    points: "271.3,206.3 271.3,171.7 306,171.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st41",
    points: "383.7,206.3 383.7,171.7 349,171.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st41",
    points: "271.3,244.7 271.3,279.3 306,279.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st41",
    points: "383.7,244.7 383.7,279.3 349,279.3  "
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 233.8,
    y: 433,
    className: "st32",
    width: 104.1,
    height: 67.4
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "338.1,479.7 338.1,433.3 264.2,433.3 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature4);
export default __webpack_public_path__ + "static/media/feature-4.44b40dd4fdf87611e6ba12fa746201a0.svg";
export { ForwardRef as ReactComponent };